import { ROUTE } from '@/config';
import { generatePath } from 'react-router-dom';

export enum TicketFormsEnum {
  ORDER = 17707453320002,
  DELIVERY = 17707471820004,
  PAYMENT = 17707486230007,
  APP = 17707491960005,
}

export enum TicketEntityIDFieldEnum {
  ORDER = 10219810140, // order platform code
  PICKUP = 11067722935, // pickup platform code
  REMITTANCE = 13511939364, // remittance platform code
}

// export const TicketEntityUIDField = 30148215813917; // for all entities
// export const TicketStatusField = 28578091769117; //for all forms
// export const TicketSolvedStatus = 28578057836445; //for all forms
export const TicketDescriptionField = 28578091767965; //for all forms

export enum TicketIssueFieldEnum {
  ORDER_ISSUES = 10025206674,
  DELIVERY_ISSUES = 13656737237,
  PAYMENT_ISSUES = 10356134903,
  APP_ISSUES = 12909112969,
}

export enum TicketOtherIssueFieldIDEnum {
  ORDER = 1002520667413,
  DELIVERY = 1035613490302,
  PAYMENT = 1365673723705,
  APP = 1290911296908,
}

export const formByEntityFieldId = {
  [TicketEntityIDFieldEnum.ORDER]: { formId: TicketFormsEnum.ORDER },
  [TicketEntityIDFieldEnum.PICKUP]: { formId: TicketFormsEnum.DELIVERY },
  [TicketEntityIDFieldEnum.REMITTANCE]: { formId: TicketFormsEnum.PAYMENT },
};

export const entityFieldList = [
  TicketEntityIDFieldEnum.ORDER,
  TicketEntityIDFieldEnum.PICKUP,
  TicketEntityIDFieldEnum.REMITTANCE,
];

export const issueFieldList = [
  TicketIssueFieldEnum.ORDER_ISSUES,
  TicketIssueFieldEnum.DELIVERY_ISSUES,
  TicketIssueFieldEnum.PAYMENT_ISSUES,
  TicketIssueFieldEnum.APP_ISSUES,
];
export const otherIssueFieldByForm = {
  [TicketFormsEnum.ORDER]: TicketOtherIssueFieldIDEnum.ORDER,
  [TicketFormsEnum.DELIVERY]: TicketOtherIssueFieldIDEnum.DELIVERY,
  [TicketFormsEnum.PAYMENT]: TicketOtherIssueFieldIDEnum.PAYMENT,
  [TicketFormsEnum.APP]: TicketOtherIssueFieldIDEnum.APP,
};

export const issueFieldByForm = {
  [TicketFormsEnum.ORDER]: TicketIssueFieldEnum.ORDER_ISSUES,
  [TicketFormsEnum.DELIVERY]: TicketIssueFieldEnum.DELIVERY_ISSUES,
  [TicketFormsEnum.PAYMENT]: TicketIssueFieldEnum.PAYMENT_ISSUES,
  [TicketFormsEnum.APP]: TicketIssueFieldEnum.APP_ISSUES,
};

export const TICKET_ENTITY_CONFIG: Record<
  string,
  (uid?: string) => {
    singlePageUrl?: string;
    entityName: string;
    entityId: TicketEntityIDFieldEnum;
  }
> = {
  BXO: (uid) => ({
    singlePageUrl: uid ? `${ROUTE.ORDER_DETAILS}/${uid}` : undefined,
    entityId: TicketEntityIDFieldEnum.ORDER,
    entityName: 'order',
  }),
  BXPU: (uid) => ({
    singlePageUrl: uid ? `${ROUTE.PICKUPS_DETAILS}/${uid}` : undefined,
    entityId: TicketEntityIDFieldEnum.PICKUP,
    entityName: 'pickup',
  }),
  BXRTO: (uid) => ({
    singlePageUrl: uid ? generatePath(ROUTE.PICKUP_RTO_DETAILS, { id: uid }) : undefined,
    entityId: TicketEntityIDFieldEnum.PICKUP,
    entityName: 'return',
  }),
  BXRE: (uid) => ({
    singlePageUrl: uid ? generatePath(ROUTE.FINANCE_DETAILS, { id: uid }) : undefined,
    entityId: TicketEntityIDFieldEnum.REMITTANCE,
    entityName: 'remittance',
  }),
};
